import React from 'react';

import { IMAGES } from '../constants';
import styles from './fableticsUpgradeCreative.scss';

const FableticsUpgradeControl = () => {
    return (
        <div
            className={styles.fableticsUpgradeCreative}
            data-testid="fabletics.upgrade-creative.control.container"
        >
            <div className={styles.textBlock}>
                <p
                    className={styles.headline}
                    data-testid="fabletics.upgrade-creative.control.headline"
                >
                    Your Tennis Passport Awaits.
                </p>
                <p
                    className={styles.subhead}
                    data-testid="fabletics.upgrade-creative.control.subhead"
                >
                    {`Sign up for Power and get `}
                    <span className={styles.emphasis}>$250 in travel value</span>
                    {' instantly.'}
                </p>
            </div>
            <div className={styles.bodyBlock}>
                <p className={styles.body}>
                    {'Plus, '}
                    <span className={styles.emphasis}>
                        $1000+ in free membership, VIP prices (up to 50% off), quarterly rewards
                    </span>
                    {', and more from'}
                </p>
                <img
                    src={IMAGES.fableticsLogo}
                    alt="Fabletics"
                    className={styles.fableticsLogo}
                />
            </div>
            <div className={styles.imagePanels}>
                <div
                    className={styles.imagePanel}
                    data-testid="fabletics.upgrade-creative.control.image-airport"
                >
                    <img
                        src={IMAGES.airport}
                        alt="Tennis player at airport with UTR Sports bag"
                        className={styles.imagePanelImg}
                    />
                </div>
                <div
                    className={styles.imagePanel}
                    data-testid="fabletics.upgrade-creative.control.image-tennis"
                >
                    <img
                        src={IMAGES.tennisWomen}
                        alt="Two tennis players in Fabletics apparel"
                        className={styles.imagePanelImg}
                    />
                </div>
            </div>
            <p
                className={styles.zipCaption}
                data-testid="fabletics.upgrade-creative.control.zip-caption"
            >
                USA billing ZIP required to access Fabletics.
            </p>
        </div>
    );
};

export default FableticsUpgradeControl;
